export const HumanGenre = {
    M: 'Homme',
    F: 'Femme',
}

export default {
    HumanGenre,
}